import { AxiosError, InternalAxiosRequestConfig } from "axios";

import { router, queryClient } from "../../main";
import { ROUTES } from "../constants/routes";
import { getAuthToken, removeAuthToken } from "../lib/auth";
import { showCabinetAccessDeniedPopup } from "../lib/show-error-popup";

export const requestHook = (config: InternalAxiosRequestConfig) => {
  try {
    const token = getAuthToken();

    if (config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  } catch (e) {
    return config;
  }
};

export const responseErrorHook = async (error: AxiosError) => {
  if (error.response?.data instanceof Blob) {
    try {
      error.response.data = JSON.parse(await error.response.data.text());
    } catch {
      /* Non-JSON file error. */
    }
  }
  const failure = error.response?.data as
    | { code?: string; message?: string }
    | undefined;
  if (error.response?.status === 403 && failure?.code?.startsWith("Cabinet.")) {
    await queryClient.cancelQueries();
    queryClient.clear();
    if (failure.code === "Cabinet.Disabled") {
      sessionStorage.removeItem("cabinet-access-message");
      removeAuthToken();
      showCabinetAccessDeniedPopup(
        failure.message ?? "Доступ в личный кабинет запрещен",
      );
      if (router.latestLocation.pathname !== ROUTES.login)
        void router.navigate({ to: ROUTES.login });
    } else if (router.latestLocation.pathname !== ROUTES.login) {
      void router.invalidate();
    }
  }
  if (
    error.response?.status === 401 &&
    router.latestLocation.pathname !== ROUTES.login
  ) {
    removeAuthToken();

    void router.navigate({
      to: ROUTES.login,
      search: {
        redirect: router.latestLocation.href,
      },
    });
  }

  return Promise.reject(error);
};
